"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getInitialProduct = require("./getInitialProduct");
Object.keys(_getInitialProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getInitialProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getInitialProduct[key];
    }
  });
});
var _getProductDetailUrl = require("./getProductDetailUrl");
Object.keys(_getProductDetailUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getProductDetailUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getProductDetailUrl[key];
    }
  });
});
var _replaceProduct = require("./replaceProduct");
Object.keys(_replaceProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _replaceProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _replaceProduct[key];
    }
  });
});
